import { Dialog } from '@mui/material';
import { FC, ReactNode } from 'react';
import { DialogContent, DialogSubTitle, DialogTitle } from '../../../shared/dialog/dialog.styles';
import { LoadingOverlay } from '../../../shared/loading-overlay/loading-overlay';
import { useApptRequestIvStatusDialog } from '../hooks/use-appt-request-iv-status-dialog/hook';

export interface ApptRequestIvStatusDialogProps {
  title: string | ReactNode;
  subtitle?: string | ReactNode;
  opened: boolean;
  children?: ReactNode;
}

export const ApptRequestIvStatusDialog: FC<ApptRequestIvStatusDialogProps> = (props) => {
  const { opened, title, subtitle, children } = props;
  const { isReady } = useApptRequestIvStatusDialog();

  return (
    <Dialog open={opened} maxWidth={false}>
      <DialogContent>
        {title && <DialogTitle>{title}</DialogTitle>}
        {subtitle && <DialogSubTitle>{subtitle}</DialogSubTitle>}
        {children}
      </DialogContent>
      <LoadingOverlay isLoading={!isReady} />
    </Dialog>
  );
};
